import React from "react";
import {useState, useEffect} from "react";
import Accordion from "react-bootstrap/Accordion";
import anime from "animejs";

const Home = () => {
    const [weather, setWeather] = useState(null);
    const weatherResource = "https://api.openweathermap.org/data/2.5/weather?q=Bahamas&units=metric&APPID=6a32deb7b63c9e7097b2ec064ef47ad4";

    async function weatherAPI() {
        try {
            const response = await fetch(weatherResource);
            const json = await response.json();
            setWeather(json);
        }
        catch (error) {
            console.error("Error occurred when fetching Weather API data", error);
        }
    }
    useEffect(() => {
        weatherAPI();
    }, []);

    anime({
        targets: '.banner',
        scale: [0.8, 1],
        duration: 800,
        easing: 'easeInOutQuad',
        delay: anime.stagger(100)
    });

    return (
        <>
            <header>
                <section className="banner">
                    <h1>Academic Accord</h1>
                    <h2>
                        Welcome to Academic Accord, where your potential is supported throughout your journey
                    </h2>
                </section>
            </header>

            <article className="weather">
                {/* if weather exists (API loaded), display data; otherwise, show loading message */}
                {weather ? (
                    <>
                        <div className="weather-icon">
                            <h3>☀️</h3>
                        </div>
                        <div className="weather-data">
                            <p className="temperature" aria-label="weather temp">{weather.main.temp}°C</p>
                            <p aria-label="weather location">{weather.name}</p>
                        </div>
                        <div className="weather-text">
                            <h3>You'll be able to retire here due to your success after using our website!</h3>
                        </div>
                    </>
                ) : (<p>Loading weather data...</p>)
                }
            </article>

            <main>
                <section aria-label="one stop solution">
                    <div className="card1">
                        <h3 className="heading3">One-stop Solution</h3>
                        <h4>Never miss another date again</h4>
                        <img className="wide-image" src={"./images/behnam-norouzi-JSWukh-Q-Cs-unsplash.jpg"}
                             alt="Image of a caldenar"/>
                    </div>
                </section>

                <section aria-label="Increase your productivity with our tools">
                    <div className="card2">
                        <div className="card2-text">
                            <p className="heading3">Increase Your Productivity</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer maximus lectus turpis,
                                et pulvinar nisi efficitur non. Etiam molestie molestie risus, vitae luctus ipsum
                                volutpat non. Proin sed velit lacus. Proin tristique non lacus sed laoreet. Phasellus
                                porttitor ultricies ultricies. Aliquam erat volutpat. Maecenas eget aliquet odio.
                                Phasellus venenatis nisl dolor, sit amet efficitur nisi semper eget. Etiam congue ac
                                ligula vel efficitur. Suspendisse at felis eget nunc venenatis pellentesque. Proin non
                                ligula aliquam sapien euismod bibendum vitae vehicula ipsum. Cras lorem risus, rhoncus
                                ut rutrum eu, pulvinar eget nulla. Vestibulum pellentesque felis arcu, eu mollis erat
                                consectetur ut. Praesent id aliquam nulla. Vivamus laoreet tincidunt lorem, eget rhoncus
                                dui auctor vel. Duis tristique euismod ultricies. </p>
                        </div>
                        <div className="card2-image">
                            <img className="flex-image" src={"./images/jeshoots-com-9n1USijYJZ4-unsplash.jpg"}
                                 alt="Image of a diary filled with notes and to do lists on a messy desk"/>
                        </div>

                    </div>
                </section>

                <Accordion aria-label="Q&A Section">
                    <h3 className="heading3" aria-label="Q&A Heading">Q&A</h3>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><h4>What is this website?</h4></Accordion.Header>
                        <Accordion.Body>
                            Lorem ipsum
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header><h4>How do I use this website?</h4></Accordion.Header>
                        <Accordion.Body>
                            Lorem ipsum
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </main>
        </>
    );
}
export default Home;